import React, { memo, useMemo } from 'react';
import {
  Breadcrumb,
  Breadcrumbs,
} from '../../interfaces/Breadcrumbs.interface';
import { withBlokWrapper } from '../BlokWrapper/BlokWrapper';
import { Theme } from '../../interfaces/enums/Theme.enum';
import Container from '../Utils/Container/Container';
import CustomLink from '../CustomLink/CustomLink';
import BreadcrumbListStructuredData from './BreadcrumbListStructuredData';

interface BreadcrumbBarProps {
  breadcrumbs: Breadcrumbs;
  theme: Theme;
}

const BreadcrumbBar: React.FC<BreadcrumbBarProps> = ({
  breadcrumbs,
  theme,
}) => {
  const previousBreadcrumb = useMemo<Breadcrumb>(() => {
    return breadcrumbs.breadcrumbs.at(-1)!; // we can unwrap this
  }, [breadcrumbs]);

  return (
    <section data-theme={theme || Theme.LIGHT}>
      <div className="bg-surface/background">
        <BreadcrumbListStructuredData breadcrumbs={breadcrumbs} />
        <Container>
          {/*-- mobile --*/}
          <div className="flex items-center justify-start h-[68px] sm:hidden">
            <span className="w-5 h-5 bg-[url('/svgs/breadcrumb-bar-back-arrow.svg')]" />
            <CustomLink
              url={previousBreadcrumb.slug}
              label={previousBreadcrumb.label}
              className="py-6 text-text/body-accent text-sm hover:underline"
            >
              {previousBreadcrumb.label}
            </CustomLink>
          </div>

          {/*-- tablet and desktop --*/}
          <ul className="hidden sm:flex sm:items-center sm:justify-start sm:h-full sm:gap-x-2 sm:text-sm">
            {breadcrumbs.breadcrumbs.map((breadcrumb: Breadcrumb) => (
              <li
                key={breadcrumb.slug}
                className="flex items-center justify-start gap-x-2 h-[68px]"
              >
                <CustomLink
                  url={breadcrumb.slug}
                  label={breadcrumb.label}
                  className="py-6 text-text/body-accent hover:underline"
                >
                  {breadcrumb.label}
                </CustomLink>
                <span className="w-5 h-5 bg-[url('/svgs/breadcrumb-bar-forward-arrow.svg')]" />
              </li>
            ))}
            <li key="currentPath" className="text-text/body-tint">
              {breadcrumbs.label}
            </li>
          </ul>
        </Container>
      </div>
    </section>
  );
};

export default memo(withBlokWrapper(BreadcrumbBar));
